import { render } from "./betDetail.vue?vue&type=template&id=ed772aee&scoped=true"
import script from "./betDetail.vue?vue&type=script&lang=js"
export * from "./betDetail.vue?vue&type=script&lang=js"

import "./betDetail.vue?vue&type=style&index=0&id=ed772aee&scoped=true&lang=css"
import "./betDetail.vue?vue&type=style&index=1&id=ed772aee&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed772aee"]])

export default __exports__